import { type ButtonProps, Link } from "@heroui/react";
import { DollarSign } from "lucide-react";

import { Button } from "../../core/Button";

export const TipButton = ({
  size,
  iconFontSize,
  ...props
}: ButtonProps & {
  iconFontSize?: number;
}) => {
  return (
    <Button
      as={Link}
      size={size ?? "sm"}
      href="https://tips.sc07.com"
      target="_blank"
      variant="ghost"
      color="success"
      {...props}
    >
      <DollarSign aria-hidden="true" size={iconFontSize ?? 16} />
      <p>Tip Jar</p>
    </Button>
  );
};
